module.exports = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>Email Icon</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="email-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Email-support" transform="translate(1.000000, 1.000000)" stroke="#0067DB">
            <circle id="email-icon" stroke-width="2" fill-rule="nonzero" cx="20" cy="20" r="20"></circle>
            <g id="-Icon---βeta-/-System-Controls-/-Inbox-/-1---24-/-3---Blue" transform="translate(8.000000, 8.000000)" stroke-linecap="round" stroke-linejoin="round">
                <g id="Messages-Inbox" transform="translate(2.000000, 5.000000)">
                    <path d="M15.9893,4.0254 L10.9233,8.0354 C10.3813,8.4634 9.6163,8.4664 9.0713,8.0434 L3.1713,3.4534 C2.7183,3.1014 2.1053,3.0384 1.5913,3.2894 C1.0763,3.5414 0.7503,4.0644 0.7503,4.6364 L0.7503,12.0004 C0.7503,12.8284 1.4223,13.5004 2.2503,13.5004 L19.2503,13.5004 L19.2503,2.0004 C19.2503,1.1714 18.5783,0.5004 17.7503,0.5004 L0.7503,0.5004" id="Stroke-1" stroke-width="1.5"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;
